/* My Acre mount price reflection (2026-08-11, Claude).

   Why this is separate from ma-mount-picker.js: the picker owns selection, filtering
   and the cart write. This file owns one job only, so it can be removed without
   touching any of that.

   The job: when the chosen mount costs extra (Serenity and Unity's free-standing base
   and wall mount at +$600, or every mount on a product that bundles none), the price
   shown on the page must already include it. Before this, the page said $4,980 while
   the extra $600 appeared only in the cart, so a shopper could pick a free-standing
   base and reasonably believe that was the price.

   Where the base price comes from, and why not the DOM: the theme re-renders the
   price element on every variant change, which detaches any observer pointed at it,
   and its data-price attribute holds the product's opening price rather than the
   selected variant's. The hidden variant <select> is the reliable source: Liquid
   renders every option as "Title - $price", so the selected option always carries the
   true price of the variant currently chosen. We read from there and re-apply after
   the theme has finished its own render.

   2026-08-12 (Claude): was calling applySoon() unconditionally on init, which on a
   product like Oasis, where every mount option is a paid upgrade and none are free,
   added the first (pre-checked) option's surcharge to the price before the customer
   had chosen anything. Oasis showed $944 on load for a $790 umbrella. Serenity and
   Unity never showed this because their default option is free (surcharge computes
   to 0 either way), so removing the initial call only changes behaviour on products
   like Oasis: first paint now matches the honest server-rendered umbrella-only price,
   and the surcharge is added from the moment the customer actually touches the form
   (picks a mount, or changes size/colour), same as it already was on every later
   interaction. */
(function () {
  function parseMoney(text) {
    var m = String(text || '').match(/\$[\s]*([0-9,]+(?:\.[0-9]{2})?)/);
    if (!m) return 0;
    var n = Number(m[1].replace(/,/g, ''));
    return isFinite(n) ? n : 0;
  }

  function formatMoney(amount) {
    return '$' + amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.dataset.maMountPriceBound) return;
    root.dataset.maMountPriceBound = '1';

    var form = root.closest('form');
    var select = (form || document).querySelector('select[data-variants]');
    if (!select) return;

    function basePrice() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return 0;
      return parseMoney(opt.textContent);
    }

    function surcharge() {
      var sel = root.querySelector('[data-ma-mount-input]:checked');
      if (!sel || sel.getAttribute('data-upgrade') !== '1') return 0;
      var variantId = sel.getAttribute('data-variant-id') || root.getAttribute('data-upgrade-variant') || '';
      if (!variantId) return 0;
      var price = sel.getAttribute('data-price') || root.getAttribute('data-upgrade-price') || '';
      var n = Number(String(price).replace(/[^0-9.]/g, ''));
      return isFinite(n) ? n : 0;
    }

    function apply() {
      var base = basePrice();
      if (!base) return;
      var total = base + surcharge();
      var text = formatMoney(total);
      /* Re-query every time: the theme replaces these nodes on variant change, so a
         cached reference goes stale and would silently stop updating. */
      var targets = [];
      var main = document.querySelector('[data-product-price-text]');
      var sticky = document.querySelector('[data-ma-sticky-price]');
      if (main) targets.push(main);
      if (sticky) targets.push(sticky);
      targets.forEach(function (el) {
        if (el.textContent.trim() !== text) el.textContent = text;
      });
    }

    /* Re-apply after the theme's own variant render lands. The theme updates the
       price asynchronously, so a single immediate pass would be overwritten; these
       staggered passes cover a slow render without polling forever. */
    function applySoon() {
      [0, 60, 180, 400, 800, 1400].forEach(function (ms) { setTimeout(apply, ms); });
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ma-mount-input')) apply();
    });

    if (form) {
      form.addEventListener('change', function (e) {
        var el = e.target;
        if (!el) return;
        var isOption = el.classList && el.classList.contains('ma-option-value__input');
        var isSelect = el === select;
        if (isOption || isSelect) applySoon();
      });
    }

    select.addEventListener('change', applySoon);
  }

  function boot() {
    document.querySelectorAll('[data-ma-mount]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
